import React, { useState, useEffect } from "react";
import s from "../styles/AddComplect.module.css"; // Подключаем модульный CSS

const ComplectList = () => {
  const [complects, setComplects] = useState([]); // Список комплектаций
  const [newComplect, setNewComplect] = useState(""); // Новая комплектация
  const [error, setError] = useState(null); // Ошибки
  const [message, setMessage] = useState(null); // Сообщения
  const [loading, setLoading] = useState(true); // Индикатор загрузки

  // 📌 Получение списка комплектаций
  useEffect(() => {
    fetch("/api/vehicle/get_complect")
      .then((res) => res.json())
      .then((data) => {
        setComplects(data);
        setLoading(false);
      })
      .catch(() => {
        setError("Ошибка загрузки данных");
        setLoading(false);
      });
  }, []);

  // 📌 Функция для добавления новой комплектации
  const handleAddComplect = async () => {
    if (!newComplect.trim()) {
      setError("Введите название комплектации");
      return;
    }

    try {
      const response = await fetch("/api/vehicle/add_complect", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ complect_name: newComplect.trim() }),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.error || "Ошибка при добавлении");
      }

      // Добавляем в список
      setComplects([...complects, { id: data.id, complect_name: newComplect.trim() }]);
      setNewComplect(""); // Очищаем поле ввода
      setMessage("Комплектация добавлена успешно");
      setError(null);
    } catch (err) {
      setError(err.message);
      setMessage(null);
    }
  };

    // 📌 Функция для удаления комплектации
    const handleDeleteComplect = async (id) => {
        try {
          const response = await fetch(`/api/vehicle/delete_complect/${id}`, {
            method: "DELETE",
          });
    
          const data = await response.json();
          if (!response.ok) {
            throw new Error(data.error || "Ошибка при удалении");
          }
    
          // Обновляем список, убираем удалённый элемент
          setComplects(complects.filter((c) => c.id !== id));
          setMessage("Комплектация удалена успешно");
          setError(null);
        } catch (err) {
          setError(err.message);
          setMessage(null);
        }
      };

  return (
    <div className={s.container}>
      <h2>Управление комплектациями</h2>

      {/* Форма для добавления новой комплектации */}
      <div className={s.form}>
        <input
          type="text"
          placeholder="Введите название комплектации"
          value={newComplect}
          onChange={(e) => setNewComplect(e.target.value)}
          className={s.input}
        />
        <button onClick={handleAddComplect} className={s.button}>
          Добавить
        </button>
      </div>

      {/* Ошибки и сообщения */}
      {error && <p className={s.error}>{error}</p>}
      {message && <p className={s.success}>{message}</p>}

      {/* Список комплектаций */}
      {loading ? (
        <p>Загрузка...</p>
      ) : (
        <ul className={s.list}>
          {complects.map((c) => (
            <li key={c.id} className={s.listItem}>{c.complect_name}
            <button className={s.dell_complect_button} onClick={() => handleDeleteComplect(c.id)}>
                ❌
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default ComplectList;
